import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.434 22.572h19.131c1.72 0 2.58 2.082 1.367 3.296l-9.566 9.565a1.921 1.921 0 0 1-2.725 0l-9.573-9.565c-1.214-1.214-.354-3.296 1.366-3.296Zm20.498-8.44-9.566-9.565a1.921 1.921 0 0 0-2.725 0l-9.573 9.565c-1.214 1.214-.354 3.296 1.366 3.296h19.131c1.72 0 2.58-2.082 1.367-3.296Z" })
});
export default SvgArrowFilter;
